import styled from 'styled-components';

interface ValueProps {
  active: boolean;
}

export const Container = styled.section`
  background: ${({ theme }) => theme.searchInput.text.background};
  color: ${({ theme }) => theme.searchInput.text.label.color};
  box-shadow: ${({ theme }) => theme.searchInput.text.boxShadow};

  height: ${({ theme }) => theme.searchInput.text.height};
  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.searchInput.text.padding};
  position: relative;
  border-radius: 8px;
  border: ${({ theme }) => theme.searchInput.text.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: ${({ theme }) => theme.searchInput.text.margin};
`;

export const Content = styled.div`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Label = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.searchInput.text.detail.top};

  font-size: ${({ theme }) => theme.searchInput.text.detail.fontSize};
  line-height: unset;
  color: ${({ theme }) => theme.searchInput.text.detail.color};
`;

export const Placeholder = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.searchInput.text.placeholder.label.top};
  font-size: ${({ theme }) => theme.searchInput.text.placeholder.label.fontSize};
  line-height: unset;
  color: ${({ theme }) => theme.searchInput.text.placeholder.label.color};
`;

export const Value = styled.span<ValueProps>`
  font-size: ${({ theme }) => theme.searchInput.text.label.fontSize};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: unset;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.text.label.color : theme.searchInput.placeholder.label.color};
  font-weight: ${({ active }) => (active ? '600' : 'normal')};
  margin-top: ${({ theme }) => theme.searchInput.text.label.marginTop};
`;
